<template>
  <div class="viewScreen">
    <div class="leftStencil">
      <div class="leftTil">
        <div>
          <FSpanTil title="模版列表" fontSize="20">{{activeStencil.moduleName}}</FSpanTil>
        </div>
      </div>
      <div class="leftList">
        <el-scrollbar>
          <div class="forList" v-for="(item,index) in stencilList" :class="{activeForList:activeStencil.id===item.id}" @click="getClickViewDp(index)">
            <div class="stencilDiv">
              <img :src="item.thumbNail" ondragstart="return false" @error="imgError">
              <div class="div_count">
                <span class="name">{{item.screenPageName}}</span>
              </div>
            </div>
            <div class="hover_div" @click.stop>
              <div class="div_FSvg" @click="getClick('upd',item.id)">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                  <FSvg title="编辑" color="#fff" hoverColor="#ddd" IconSize="14"></FSvg>
                </el-tooltip>
              </div>
              <div class="div_FSvg" @click="getviewDpBtn(item.id,'del')">
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                <FSvg title="删除" color="#fff" hoverColor="#ddd" IconSize="16"></FSvg>
                </el-tooltip>
              </div>
              <div class="div_FSvg fullSvg" @click="getClick('full',item.id)">
                <el-tooltip class="item" effect="dark" content="全屏" placement="top">
                <FSvg title="全屏" color="#fff" hoverColor="#ddd" IconSize="16"></FSvg>
                </el-tooltip>
              </div>
              <div class="div_FSvg copySvg" @click="getviewDpBtn(item.id,'copy')">
                <el-tooltip class="item" effect="dark" content="复制" placement="top">
                <FSvg title="复制" color="#fff" hoverColor="#ddd" IconSize="19"></FSvg>
                </el-tooltip>
              </div>
              <div class="div_FSvg copySvg" @click="getShare(0);getClick('share',item.id,index)">
                <el-tooltip class="item" effect="dark" content="分享" placement="top">
                <FSvg title="分享" color="#fff" hoverColor="#ddd" IconSize="16"></FSvg>
                </el-tooltip>

              </div>
            </div>
          </div>
          <div class="addList" @click="getClick('add')">
            <div class="pseDiv">
              <div>
                <div>
                  <svg viewBox="0 0 1024 1024" version="1.1" style="width: 24px; height: 24px; fill: rgb(221, 221, 221);">
                    <path d="M511.950015 1024c-41.887728 0-75.977741-34.090013-75.977741-75.977741v-359.894562H75.977741c-41.887728 0-75.977741-34.090013-75.977741-75.977741s34.090013-75.977741 75.977741-75.977741h360.094503V75.977741c0-41.887728 34.090013-75.977741 75.977741-75.977741s75.977741 34.090013 75.977741 75.977741v360.094503H947.722347c41.887728 0 75.977741 34.090013 75.977741 75.977741s-34.090013 75.977741-75.977741 75.977741H587.927756V947.722347c0.199941 42.18764-34.090013 76.277653-75.977741 76.277653z" p-id="23429"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="rigStencil">
      <div class="rigTil">
        <div>
          <FSvg title="模块" color="#333" hoverColor="#333"></FSvg>
        </div>
        <span>{{activeStencil.til}}</span>
        <!--<FBtn @click="getClick('upd')">编辑</FBtn>-->
      </div>
      <div class="rigCount">
        <div class="rigCount_div" v-loading="preview.load" id="viewScreen_Fa_body" element-loading-background="rgba(28, 44, 76, 0.72)">
          <div v-if="preview.show" id="viewScreen_FCanvas_body">
            <el-scrollbar ref="viewScreenScrollbar" class="canvasScrollbar" :native="false">
              <preview :toChartData="newchartData" id="viewScreen_FCanvas" @handleClickData="getchildList" @handleClickData3="getOptionId"></preview>
            </el-scrollbar>
          </div>
          <div class="comNoData" v-else>
            <span>暂无图表</span>
          </div>
        </div>
      </div>
      <!-- 滑块 -->
      <div class="centCanvas_block">
        <el-slider v-model="slider.value" @input="getCanvasResize" @change="getCanvasResize"></el-slider>
      </div>
    </div>
    <FDialog class="share" :dialog="Share.dialog" :title="Share.title" moveWidth="465px" @close="getShare(1)">
      <div id="first">
        <div class="share_tit"><span>分享</span></div>
        <div class="share_setup">
          <div class="left">
            <div class="eyes"></div>
          </div>
          <div class="screen_Name">{{activeStencil.til}}
            <!-- <el-switch v-model="sharePsd" active-text="加密" active-color="#409EFF" inactive-text="">
            </el-switch> -->
          </div>
          <div class="shareMan">任何人都可查看</div>
          <div class="bottom">
            <span class="shareData">文件访问{{checkedData}}有效</span>
            <button class="shareBtn" @click="setShareData()">+设置链接有效期</button>
          </div>
          <div class="link_expire_panel" v-if="showHide">
            <ul>
              <li :class="{checked:shareChecked==index}" v-for="(item,index) in shareList" :key="index" @click="chooseChecked(item.name,index)">
                <p class="name">{{item.name}}</p>
                <p class="content">{{item.content}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="share_way_panel">
          <p class="title">分享至</p>
          <div class="way_list">
            <!-- <div class="way_item wechat">
              <button></button>
              <p>微信好友</p>
            </div> -->
            <div class="way_item link" @click="copyLinkPage();submitLS()">
              <button></button>
              <p>复制链接</p>
            </div>
            <!-- <div class="way_item emali">
              <button></button>
              <p>发送邮件</p>
            </div>
            <div class="way_item qrcode">
              <button></button>
              <p>生成二维码</p>
            </div> -->
          </div>
        </div>
      </div>
      <div id="copyLink" style="display:none">
        <div class="share_tit" style="none"><span id="screenTopic">大屏主题</span></div>
        <div><span id="screenName">大屏名称：{{activeStencil.til}}</span></div>
        <div><span id="screenPerson">邀请人：{{screenUser}}</span></div>
        <div><span id="screenLink">邀请链接：</span></div>
        <!-- <div><a id="href" target="_blank" @click="href()">{{https}}</a></div> -->
        <!-- <el-link class="url" type="primary" :href="linkSharing.url+'?storyBoardID='+activeStory.id">{{linkSharing.url}}?storyBoardID={{activeStory.id}}</el-link> -->
        <!-- <div><a id="href" @click="href()" target="_blank">{{linkSharing.url}}?storyBoardID={{shareId}}</a></div> -->
        <div><a :href="before+'#/shareScreen/'+CaptchaID+shareId" target="_blank">{{before}}#/shareScreen/{{CaptchaID}}{{shareId}}</a></div>
        <!-- <div><span id="screenPassword">密码：{{linkSharing.dataTabel}}</span></div> -->
        <div><span id="screenData">有效期：{{checkedData}}</span></div>
        <div class="button">
          <el-button type="info" size="small" @click="copyAll()">复制全部信息</el-button>
          <el-button type="primary" size="small" @click="copyLink()">复制该链接</el-button>
        </div>
      </div>
    </FDialog>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/4/10 2:59 下午
 */
import {
  GetScreenByGroupID,
  RemoveScreen,
  SetScreenCopy
} from '@/assets/axios/createScreen/viewScreen'
import preview from '../preview/preview';
import { pathFullScreen } from '@/assets/js/basis.js'
import { GetEchartsData } from '@/assets/axios/dataUpload/createViewDP'
import backChart from '../../charts/backChart'
import {
  //获取故事版内容详情
  getTeamSharingContent,

} from '@/assets/axios/teamSharing/setContents'

import {
  //获取中心管控列表
  getTeamSharingList,
  //创建新组查看名字是否重复
  getTeamSharingUserIdentical,
  //添加或修改中心管控
  addorModifyTeamSharing,
  //删除中心管控组
  removeTeamSharing,
  //获取当前用户组下面的成员列表
  GetTeamSharingMembers,
  //给故事版添加团队分享人员
  addTeamSharingPersonnel,
  //给故事版添加链接分享
  SetScreenLinkSharing
} from '@/assets/axios/teamSharing/teamSharing'




export default {
  name: 'viewScreen',
  components: {
    preview,
    backChart
  },
  props: {},
  data() {
    return {
      CaptchaID: "",
      before: "",
      shareId: "",
      // sharePsd: true,
      screenUser: "",
      https: "",
      showHide: false,
      checkedData: "永久",
      shareChecked: 0,
      Share: {
        dialog: false,
        title: '大屏分享',
        type: 0,
      },
      shareList: [
        {
          name: "永久有效",
          content: "适用于个人主页，公开资料",
        },
        {
          name: "7天",
          content: "适用于小组或部门内分享，7天后失效，他人将无法访问文档",
        },
        {
          name: "1天",
          content: "适用隐私性较强的内部文档",
        },
      ],
      //id
      newchartData: {},
      viewId: "",
      childList: [],
      optionId: "",
      viewScree: {
        //模版id
        modeId: '',
        //大屏id
        viewDPId: ''
      },
      //模版列表
      stencilList: [],
      //选中的模版
      activeStencil: {
        id: 0,
        moduleName: '',
        til: '',
      },
      //预览
      preview: {
        show: false,
        load: true,
      },
      //滑块
      slider: {
        value: 100,
      },
      softCount: "",
      mbxList2: [],
      json: [],





      //故事版列表
      teamSharingList: [],
      //故事版列表中选中的数据
      activeStory: {
        id: null,
        name: ''
      },
      //内容展示列表
      dragElementList: [],
      //是否由内容
      totalCountShow: false,
      //大屏尺寸
      canvasPage: {
        height: 1080,
        width: 1200
      },
      //菜单列表
      menuList: [
        {
          name: '编辑',
          operation: 'setContents'
        },
        {
          name: '团队分享',
          operation: 'teamSharing'
        },
        {
          name: '链接共享',
          operation: 'linkSharing'
        },
        {
          name: '删除',
          operation: 'removeTeamSharing'
        },
      ],
      //中心管控弹框列表
      teamSharingDialog: false,
      // 中心管控树形配置 ztree
      setting: {
        check: {
          enable: true
        },
        data: {
          simpleData: {
            enable: true
          },
          key: {
            children: 'children',
            name: 'name'
          }
        },
        callback: {
          //点击
          onClick: (e, treeId, treeNode) => {
            var treeObj = $.fn.zTree.getZTreeObj("treeDemo"),
              nodes = treeObj.getCheckedNodes(true),
              v = "";
            for (var i = 0; i < nodes.length; i++) {
              v += nodes[i].name + ",";
            }

          },
          onCheck: (e, treeId, treeNode) => {
            var treeObj = $.fn.zTree.getZTreeObj("treeDemo");
            let a = [];
            treeObj.getCheckedNodes().map((val) => {
              if (val.isParent === false) {
                a.push(val.id);
              }
            })
            _this.memberList = a;
          }
        },
      },
      // 中心管控树形数据
      zNodes: [],
      // 中心管控提交的人员数组
      memberList: [],
      //链接共享弹框
      linkSharing: {
        show: false,
        //链接共享
        linkSharingDay: '',
        //链接共享地址
        // url: 'http://47.105.165.74:8057/#/linkSharing',
        // url: 'http://192.168.1.148:8850/#/shareScreen',
        //验证码
        dataTabel: ''
      },
      //链接弹框
      link: {
        show: false
      }



    }
  },
  methods: {
    // 获取故事版列表
    getTeamSharingList() {
      // 获取故事版列表
      getTeamSharingList().then((data) => {
        if (data.code === 200) {
          if (data.data.dataTabel !== "") {
            this.teamSharingList = data.data.dataTabel;
            this.activeStory = this.teamSharingList[0];
            this.getElementContent(this.activeStory.id)
          }
        }
      })
    },
    // 获取页面内容
    getElementContent(id) {
      if (id !== undefined) {
        getTeamSharingContent({ storyBoardID: id }).then((res) => {
          if (res.code === 200) {
            if (res.message !== '无值') {
              this.dragElementList = [];
              res.data.dataTable.info.map((val) => {
                let a = {};
                a = JSON.parse(val.contentJson);
                a.chartBoxId = val.id;
                a.storyBoardID = val.storyBoardID;
                if (a.type === 0) {
                  this.createChart(a.chartData, a.chartBoxId);
                }
                this.dragElementList.unshift(a);
              });
              this.zIndexList = JSON.parse(res.data.dataTable.rankJson) || [];
              //根据zIndexList 重新排列 dragElementList
              this.setElementContentIndexRefresh();
              this.rearrangedragElementList('dragList');
              this.canvasPage.height = res.data.dataTable.height;
              // this.dragElementList = JSON.parse(res.data.dataTable[0].contentJson);
              // this.canvasPage.height = res.data.dataTable[0].height;
            }
          }
        })
      }
    },
    // 刷新dragElementList中的zindex
    setElementContentIndexRefresh() {
      this.zIndexList.map((zv) => {
        this.dragElementList.map((ev) => {
          if (zv.id === ev.chartBoxId) {
            ev.transF.zIndex = zv.zIndex;
          }
        })
      });
    },
    //根据zIndex重新排列dragElementList
    rearrangedragElementList(type) {
      if (type === 'dragList') {
        var len = this.dragElementList.length;
        for (var i = 0; i < len - 1; i++) {
          for (var j = 0; j < len - 1 - i; j++) {
            // 相邻元素两两对比，元素交换，大的元素交换到后面
            if (this.dragElementList[j].transF.zIndex < this.dragElementList[j + 1].transF.zIndex) {
              var temp = this.dragElementList[j];
              this.dragElementList[j] = this.dragElementList[j + 1];
              this.dragElementList[j + 1] = temp;
            }
          }
        }
      } else if (type === 'zIndex') {
        var len = this.zIndexList.length;
        for (var i = 0; i < len - 1; i++) {
          for (var j = 0; j < len - 1 - i; j++) {
            // 相邻元素两两对比，元素交换，大的元素交换到后面
            if (this.zIndexList[j].zIndex < this.zIndexList[j + 1].zIndex) {
              var temp = this.zIndexList[j];
              this.zIndexList[j] = this.zIndexList[j + 1];
              this.zIndexList[j + 1] = temp;
            }
          }
        }
        this.setElementContentIndexRefresh();
      }

    },
    //创建新的故事版
    createTeamSharing() {
      this.$prompt('请输入共享组名称', '创建共享组', {
        closeOnClickModal: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        getTeamSharingUserIdentical({ storyBoardName: value }).then((data) => {
          if (data.code === 200) {
            addorModifyTeamSharing(value).then((data) => {
              if (data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '创建成功！'
                });
                this.getTeamSharingList()
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消创建'
        });
      });
    },
    //选择中心管控内容中的一项
    selectTeamSharingList(item) {
      this.activeStory = item;
      this.getElementContent(this.activeStory.id);
    },
    //生成真实数据图表
    createChart(data, boxId) {
      let oData = data;
      if (boxId !== undefined) {
        oData.id += boxId;
      }
      let modu = modules;
      let nodeData = oData;
      this.$nextTick(() => {
        this.$store.dispatch('viewDPSnapshot', { modu, nodeData });
      })
    },
    //初始化
    getInitial() {
      this.getTeamSharingList()
    },
    //菜单操作
    menuOperation(operation) {
      if (operation === 'setContents') {
        this.$router.push({ path: '/setContents', query: { id: this.activeStory.id } })
      } else if (operation === 'teamSharing') {
        this.teamSharingDialog = true;
        this.getL1Ztree();
      } else if (operation === 'linkSharing') {
        this.linkSharing.show = true
      } else if (operation === 'removeTeamSharing') {
        this.$alert('删除后无法恢复，还要继续删除吗？', '删除共享组', {
          confirmButtonText: '确定',
          callback: action => {
            removeTeamSharing({ 'storyBoardID': this.activeStory.id }).then((data) => {
              if (data.code === 200) {
                this.getTeamSharingList();
                this.$message({
                  type: 'success',
                  message: `删除成功！`
                });
              }
            })

          }
        });

      }
    },
    //团队分享功能 获取限权人员列表 并且加入
    getL1Ztree() {
      GetTeamSharingMembers().then(res => {
        if (res.code === 200) {
          this.zNodes = res.data.dataTable
        }
      })
      setTimeout(() => {
        $.fn.zTree.init($('#treeDemo'), this.setting, this.zNodes);
      }, 200)
    },
    //提交团队分享
    submitTS() {
      let data = {
        "storyBoardID": this.activeStory.id,
        "groupMemberID": this.memberList.toString(),
        "accesslink": `${this.linkSharing.url}?storyBoardID=${this.shareId}`,
      };
      addTeamSharingPersonnel(data).then(res => {
        if (res.code === 200) {
          this.teamSharingDialog = false;
          this.$message({
            message: res.message,
            type: 'success'
          });
        }
      })
    },
    //链接共享提交
    submitLS() {
      if (this.checkedData === "7天") {
        this.linkSharing.linkSharingDay = 7
      } else if (this.checkedData === "1天") {
        this.linkSharing.linkSharingDay = 1
      } else if (this.checkedData === "永久") {
        this.linkSharing.linkSharingDay = "永久"
      }
      let data = {
        "ScreenID": this.shareId,
        "sharingTime": this.linkSharing.linkSharingDay,
        "accesslink": `${this.before}#/shareScreen/${this.CaptchaID}/${this.shareId}`,
      };
      SetScreenLinkSharing(data).then(res => {
        if (res.code === 200) {
          this.linkSharing.dataTabel = res.data.dataTabel;
          this.CaptchaID = res.data.capID
          this.linkSharing.show = false;
          this.link.show = true;
        }
      })
    },
    //复制验证码
    clickCopy() {
      var a = document.getElementById("verification");
      a.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: '复制成功！',
        type: 'success'
      });
    },
    //跳转至displayWindow
    jumpSetContents(id) {

    },







    copyLinkPage() {
      var first = document.getElementById("first")
      first.style.display = "none"
      var copyLink = document.getElementById("copyLink")
      copyLink.style.display = "block"
      var user = JSON.parse(localStorage.getItem('user_data'))
      this.screenUser = user.userName
    },
    copyLink() {
      var text = `${this.before}#/shareScreen/${this.CaptchaID}${this.shareId}`
      // var text = this.linkSharing.url + '?storyBoardID=' + this.activeStory.id
      var copy = function (e) {
        e.preventDefault();
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', text);
        } else if (window.clipboardData) {
          window.clipboardData.setData('Text', text);
        }
      }
      this.getMsg('复制成功', 'success');
      window.addEventListener('copy', copy);
      document.execCommand('copy');
      window.removeEventListener('copy', copy);
    },
    copyAll() {
      var screenTopicHtml = "智呈可视化工具平台大屏分享"
      var screenName = document.getElementById("screenName")
      var screenNameHtml = screenName.innerHTML
      var screenPerson = document.getElementById("screenPerson")
      var screenPersonHtml = screenPerson.innerHTML
      var screenLink = document.getElementById("screenLink")
      var screenLinkHtml = screenLink.innerHTML
      var screenData = document.getElementById("screenData")
      var screenDataHtml = screenData.innerHTML
      var text = `${screenTopicHtml}\n${screenNameHtml}\n${screenPersonHtml}\n${screenLinkHtml}${this.before}#/shareScreen/${this.CaptchaID}${this.shareId}\n${screenDataHtml}`
      var copy = function (e) {
        e.preventDefault();
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', text);
        } else if (window.clipboardData) {
          window.clipboardData.setData('Text', text);
        }
      }
      this.getMsg('复制成功', 'success');
      window.addEventListener('copy', copy);
      document.execCommand('copy');
      window.removeEventListener('copy', copy);
    },
    href() {
      var href = document.getElementById("href")
      href.href = this.https;
    },
    setShareData() {
      this.showHide = !this.showHide;
    },
    chooseChecked(Name, index) {
      this.shareChecked = index
      this.checkedData = Name;
      this.checkedData = this.checkedData.substring(0, 2)
      this.showHide = !this.showHide
    },
    getShare(type) {
      if (type === 0) {
        this.Share.dialog = true;
      }
      else if (type === 1) {
        this.Share.dialog = false;
      }
    },
    getchildList(childList) {
      this.childList = childList
    },
    getOptionId(optionId) {
      this.optionId = optionId
    },
    resize() {
      this.getBodyCanvas();
    },
    //init
    async init() {
      //获取模版ID
      let modeId = await this.getSession('screen_module_xy');
      //获取图表ID
      let viewDPId = await this.getSession('screen_viewDp_xy');
      if (modeId) {
        this.viewScree.modeId = modeId;
      }
      if (viewDPId) {
        this.viewScree.viewDPId = viewDPId;
      }
      this.delSession('screen_type_xy');
      if (!this.viewScree.modeId) {
        return this.getRouterPath('/stencilList');
      }
      await this.getmodeIdChiList();
    },
    //图片加载失败
    imgError(event) {
      let index = this.randomNum(0, 2).toFixed(0);
      $(event.target).attr('src', require(`./img/dp0${index}.jpg`))
    },
    //模版ID 查询 所有大屏
    async getmodeIdChiList() {
      await GetScreenByGroupID({
        groupID: this.viewScree.modeId
      }).then(async res => {
        if (res.code === 200) {
          try {
            this.stencilList = res.data.child;
            if (this.stencilList.length) {
              for (let item of this.stencilList) {
                if (!item.thumbNail) {
                  item.thumbNail = '';
                }
              }
              if (!this.viewScree.viewDPId) {
                await this.getClickViewDp(0);
              } else {
                let count = 0;
                for (let item of this.stencilList) {
                  if (item.id === this.viewScree.viewDPId) {
                    count = 1;
                    this.activeStencil.id = item.id;
                    this.activeStencil.til = item.screenPageName;
                    this.activeStencil.moduleName = item.screenName;
                    await this.getScreenIdDetailed();
                  }
                }
                if (count === 0) {
                  await this.getClickViewDp(0);
                }
              }
            } else {
              this.preview.load = false;
              this.activeStencil.moduleName = res.data.screenName;
            }
          } catch (e) {
            this.getMsg('抱歉 出现错误!');
            return this.getRouterPath('/stencilList');
          }
        } else {
          return this.getRouterPath('/stencilList');
        }
      }).catch(() => {
        return this.getRouterPath('/stencilList');
      })
    },
    //大屏id 查询 详细信息
    getScreenIdDetailed() {
      setTimeout(() => {
        this.preview.show = true;
        this.getPreviewWid();
        setTimeout(() => {
          this.preview.load = false;
          this.getBodyCanvas();
        }, 1000)
      }, 100)
    },
    //点击某一个大屏
    async getClickViewDp(index) {
      if (!this.stencilList.length) {
        this.preview.load = true;
        setTimeout(() => {
          this.preview.show = false;
          setTimeout(() => {
            this.preview.load = false;
          }, 1000)
        }, 100);
        return;
      }
      if (this.stencilList[index].id === this.activeStencil.id) {
        return;
      }
      this.preview.load = true;
      this.preview.show = false;
      this.activeStencil.id = this.stencilList[index].id;
      this.activeStencil.til = this.stencilList[index].screenPageName;
      this.activeStencil.moduleName = this.stencilList[index].screenName;
      this.slider.value = 100;
      this.setSession({
        'screen_viewDp_xy': this.activeStencil.id
      });
      await this.getScreenIdDetailed();
    },
    //大屏按钮
    getviewDpBtn(id, type) {
      if (type === 'del') {
        this.$alert('是否删除当前大屏?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          customClass: 'alert_allCom',
        }).then(() => {
          this.delScreen(id);
        }).catch(() => {

        });
      } else if (type === 'copy') {
        SetScreenCopy({
          screenID: id
        }).then(res => {
          if (res.code === 200) {
            let data = res.data;
            this.stencilList.push({
              id: data.id,
              pageIndex: data.pageIndex,
              screenName: data.screenName,
              screenPageName: data.screenPageName,
              thumbNail: data.thumbNail,
            })
          }
        })
      }
    },
    //删除单个大屏
    delScreen(id) {
      RemoveScreen({
        screenID: id
      }).then(res => {
        if (res.code === 200) {
          this.getMsg('删除成功', 'success');
          this.stencilList.map((item, index) => {
            if (item.id === id) {
              this.stencilList.splice(index, 1);
            }
          });
          if (this.activeStencil.id === id) {
            this.getClickViewDp(0);
          }
        }
      })
    },
    //点击事件
    getClick(type, id, index) {
      if (type === 'add') {
        this.setSession({
          'screen_type_xy': 'add',
        });
        this.getRouterPath('/configScreen');
      } else if (type === 'upd') {
        this.setSession({
          'screen_type_xy': 'upd',
          'screen_viewDp_xy': id
        });
        this.getRouterPath('/configScreen');
      } else if (type === 'full') {
        pathFullScreen({
          id: id
        })
      } else if (type === 'share') {
        this.activeStencil.til = this.stencilList[index].screenPageName;
        this.https = window.location.href.replace("viewScreen", `shareScreen/${id}`)

        this.getInitial();
        this.getL1Ztree();
        this.shareId = id;
      }
    },
    //滑块改变
    getCanvasResize() {
      if (this.slider.value < 30) {
        this.slider.value = 30;
      }
      $('#viewScreen_FCanvas').css({
        'transform': 'scale(' + (this.slider.value / 100) + ') translate(0px, 0px)',
        'transform-origin': '0 0'
      });
      this.$refs.viewScreenScrollbar && this.$refs.viewScreenScrollbar.update();
    },
    //获取canvas父级宽高
    getBodyCanvas() {
      this.$nextTick(() => {
        let width = $('#viewScreen_FCanvas_body').width();
        let height = $('#viewScreen_FCanvas_body').height();
        $('#viewScreen_FCanvas_body').find('.el-scrollbar__view').css({
          'max-height': height,
          'max-width': width,
        })
      })
    },
    //获取预览的宽度
    getPreviewWid() {
    },
  },
  watch: {
    viewId() {
    },
  },
  created() {
    if (localStorage.getItem('upd')) {
      localStorage.setItem('upd', '');
      this.$router.go(0)
    }
    this.before = window.location.href.split('#')[0]
  },
  mounted() {
    this.init();
  },
  computed: {
    state() {
      return this.$store.state;
    },
  },
  destroyed() {
  }
}
</script>

<style lang="less">
@borderRadio: 5px;
@borderColor: #ccc;
@shadow: 0 0 15px @h_top_backColor;
@axtive_shadow: 0 0 15px #cb0000;
//大屏一行展示多少条
@dp_size: 4;

.viewScreen {
  position: relative;
  // background-color: @h_main_backColor !important;
  padding: 0 !important;

  .leftStencil {
    width: 16%;
    margin-right: 1%;
    height: 100%;
    float: left;
    display: inline-block;
    .noSelect;

    .leftTil {
      display: inline-block;
      width: 100%;
      margin-bottom: 15px;

      > div {
        background-color: @h_path_backColor;
        border-radius: @borderRadio;
        padding: 7px 15px;
        line-height: 30px;
        position: relative;

        .FSpanTil {
          vertical-align: middle;

          svg {
            margin-top: -2px;
          }
        }
      }
    }

    .leftList {
      display: inline-block;
      width: 100%;
      height: calc(100% - 30px - 14px - 15px);
      background-color: #fff;
      border-radius: @borderRadio;
      /*padding: ;*/

      .forList {
        position: relative;
        margin-bottom: 5%;
        width: 94%;
        height: 0;
        padding-bottom: 55%;
        cursor: pointer;
        border-radius: @borderRadio;

        > .stencilDiv {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: @borderRadio;

          > img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          }

          .div_count {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;

            .name {
              position: absolute;
              width: 100%;
              line-height: 35px;
              font-size: 18px;
              color: @green;
              display: inline-block;
              bottom: 0;
              padding: 0 10px;
              text-align: right;
              letter-spacing: 3px;
              .text_oneLine;
            }
          }
        }

        .hover_div {
          position: absolute;
          top: 0;
          width: 100%;
          height: 0;
          overflow: hidden;
          background-color: rgba(173, 173, 173, 0.5);
          border-radius: @borderRadio;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          z-index: 2;
          transition: 0.3s height;
          padding: 0 10px;

          .div_FSvg {
            float: right;
            width: 18px;
            height: 18px;
            margin-right: 10px;
            margin-top: 6px;
          }

          .div_FSvg:first-child {
            margin-right: 5px;
          }

          .fullSvg {
            margin-right: 7px;
          }

          .copySvg {
            margin-top: 5px;
          }
        }
      }

      .activeForList {
        box-shadow: @axtive_shadow !important;

        .hover_div {
          height: 30px;
        }
      }

      .forList:hover {
        box-shadow: @shadow;

        .hover_div {
          height: 30px;
        }
      }

      .addList {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 55%;
        overflow: hidden;
        cursor: pointer;
        border-radius: @borderRadio;

        .pseDiv {
          position: absolute;
          top: 0;
          left: 0;
          width: 94%;
          height: 100%;
          padding: 5%;
          border: 1px solid @borderColor;
          background-color: @h_path_backColor;
          border-radius: @borderRadio;

          > div {
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);

            > div {
              text-align: center;

              svg {
                width: 46% !important;
                height: 46% !important;
              }
            }
          }
        }
      }

      .addList:hover {
        box-shadow: @shadow;

        svg {
          fill: @green !important;
          width: 30% !important;
          height: 30% !important;
        }
      }

      .el-scrollbar {
        width: 100%;
        height: 100%;
        .el-scrollbar__wrap {
          overflow-x: hidden;
          padding: 5%;
          margin-bottom: 0px !important;
        }
      }
    }
  }

  .rigStencil {
    background-color: @h_path_backColor;
    border-radius: @borderRadio;
    height: 100%;
    width: calc(100% - 17%);
    float: left;
    display: inline-block;
    padding: 5px 5px 20px;
    position: relative;

    > .rigTil {
      line-height: 30px;
      padding: 10px 15px 0;

      > div {
        display: inline-block;
        float: left;
        vertical-align: middle;
        margin-top: -1px;
      }

      > span {
        display: inline-block;
        margin-left: 10px;
        color: @fontColor;
        float: left;
        font-size: 20px;
        letter-spacing: 3px;
        max-width: 400px;
        .text_oneLine;
      }

      .FBtn {
        float: right;
      }
    }

    > .rigCount {
      width: 100%;
      height: calc(100% - 50px);
      padding: 15px;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;

      .rigCount_div {
        width: 100%;
        height: 100%;
        position: relative;

        #viewScreen_FCanvas_body {
          width: 100%;
          height: 100%;

          .el-scrollbar {
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }

            .el-scrollbar__view {
            }
          }
        }
      }
    }

    .centCanvas_block {
      position: absolute;
      bottom: 5px;
      right: 30px;
      width: 15%;
    }
  }
}
.share {
  .share_tit {
    height: 50px;
    span {
      color: #0d7bf7;
      border-bottom: 2px solid #0d7bf7;
      line-height: 20px;
      padding-bottom: 2px;
    }
  }
  .share_setup {
    width: 100%;
    height: 144px;
    border: 1px solid hsla(0, 0%, 87%, 0.58);
    border-radius: 2px;
    padding: 23px 24px 20px 19px;
    position: relative;
    .left {
      display: inline-block;
      vertical-align: top;
      width: 80px;
      height: 112px;
      line-height: 100px;
      margin-right: 38px;
      text-align: center;
      background: url("./img/share.png") no-repeat;
      background-position: 0 -48px;
      .eyes {
        display: inline-block;
        vertical-align: middle;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: url("./img/share.png") no-repeat;
        -webkit-box-shadow: 0 5px 5px 0 rgb(0 0 0 / 6%);
        box-shadow: 0 5px 5px 0 rgb(0 0 0 / 6%);
        background-position: -70px 13px;
      }
    }
    .screen_Name {
      display: block;
      max-width: 100%;
      line-height: 23px;
      color: #26282b;
      font-size: 16px;
      overflow: hidden;
      -o-text-overflow: ellipsis;
      text-overflow: ellipsis;
      white-space: nowrap;
      .el-switch {
        float: right;
        margin-top: 3px;
      }
      .el-switch__label.is-active {
        color: #0d7bf7;
        font-size: 12px;
      }
    }
    .shareMan {
      display: block;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #0d7bf7;
    }
    .bottom {
      position: absolute;
      bottom: 20px;
      right: 28px;
      .shareData {
        position: relative;
        display: inline-block;
        width: auto;
        height: 24px;
        line-height: 24px;
        padding: 0 15px;
        background: #f1f5f9;
        text-align: center;
        font-size: 12px;
        color: #747a81;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
      .shareBtn {
        width: 118px;
        height: 24px;
        margin-left: 11px;
        background-color: #fff;
        border: 1px solid #dfdfdf;
        text-align: center;
        font-size: 12px;
        color: #80868d;
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
      }
      .shareBtn:hover {
        background-color: #0d7bf7;
        border-color: #0d7bf7;
        color: #fff;
      }
    }
    .link_expire_panel {
      background: red;
      position: absolute;
      top: 124px;
      right: -20px;
      width: 250px;
      height: 220px;
      z-index: 10;
      background-color: #fff;
      -webkit-box-shadow: 0 6px 8px 0 rgb(0 0 0 / 6%);
      box-shadow: 0 6px 8px 0 rgb(0 0 0 / 6%);
      border-radius: 4px;
      border: 1px solid #eaedf1;
      ul {
        width: 100%;
        height: 100%;
        padding: 20px 28px 20px 23px;
        .checked,
        li {
          position: relative;
          margin-bottom: 30px;
          white-space: normal;
          cursor: pointer;
          .name {
            padding-left: 32px;
            font-size: 14px;
            font-weight: 700;
            color: #3c3f43;
          }
          .content {
            padding-left: 32px;
            font-size: 12px;
            color: #acb5c0;
            line-height: 16px;
          }
        }
        li:hover .name {
          color: #0d7bf7;
        }
        .checked::before {
          content: "";
          position: absolute;
          left: 0;
          top: 2px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 0;
          background: url("./img/checked.png");
          background-size: contain;
        }
        li::before {
          content: "";
          position: absolute;
          left: 0;
          top: 2px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: #fff;
          border: 1px solid #ced2d8;
        }
      }
    }
  }
  .share_way_panel {
    margin-top: 40px;
    .title {
      color: #787d82;
      font-size: 12px;
      margin-bottom: 30px;
    }
    .title::before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      height: 1px;
      width: 40%;
      background: #e5e5e5;
      margin-right: 20px;
    }
    .title::after {
      content: "";
      display: inline-block;
      vertical-align: middle;
      height: 1px;
      width: 40%;
      background: #e5e5e5;
      margin-left: 20px;
    }
    .way_list {
      color: #787d82;
      font-size: 12px;
      margin-bottom: 30px;
      text-align: center;
      .way_item {
        display: inline-block;
        vertical-align: top;
        // margin-right: 55px;
        button {
          width: 60px;
          height: 60px;
          line-height: 60px;
          border-radius: 50%;
          background: #fff url("./img/share.png") no-repeat;
          outline: none;
          border: none;
          font-size: 12px;
        }
        p {
          margin-top: 8px;
          text-align: center;
          font-size: 12px;
          color: #666f79;
        }
      }
      .way_item:nth-child(4n) {
        margin-right: 0;
      }
      .wechat {
        button {
          background-position: 12px -178px;
          background-color: #00c785;
        }
      }
      .link {
        button {
          background-position: -55px -176px;
          background-color: #ffd481;
        }
      }
      .emali {
        button {
          background-position: -130px -176px;
          background-color: #77b9f6;
        }
      }
      .qrcode {
        button {
          background-position: -208px -179px;
          background-color: #696969;
        }
      }

      .way_item:hover button {
        opacity: 0.7;
      }
    }
  }
  #copyLink {
    div {
      min-height: 30px;
      line-height: 30px;
      font-size: 16px;
    }
    div:nth-of-type(5) a {
      color: #0d7bf7;
      text-decoration: none;
      text-decoration-color: transparent;
    }
    div:nth-of-type(5) a:hover {
      text-decoration: underline;
      text-decoration-color: #0d7bf7ed;
    }
    .button {
      width: 100%;
      margin-top: 30px;
      padding-left: 60px;
      .el-button {
        margin: 0 20px;
      }
    }
  }
}
</style>